import { createApi } from '@reduxjs/toolkit/dist/query/react'
import baseQueryWithReauth from '../../app/baseQueryWithOnlineCourse'
import { GroupSubjectState } from '../types'

interface createGroupSubjectParams {
    groupId: number
    groupSubject: GroupSubjectState
}

export const groupSubjectApiSlice = createApi({
    reducerPath: 'groupSubjectApi',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['GroupSubject'],
    endpoints: (build) => ({
        fetchAllGroupSubjects: build.query<any, number>({
            query: (id) => ({
                url: `student-group/${id}/subjects`,
            }),
            providesTags: (result) =>
                result
                    ? [
                          ...result.map(({ id }) => ({
                              type: 'GroupSubject' as const,
                              id,
                          })),
                          { type: 'GroupSubject', id: 'LIST' },
                      ]
                    : [{ type: 'GroupSubject', id: 'LIST' }],
            transformResponse: (response: any) => response.data,
        }),

        createGroupSubject: build.mutation<void, createGroupSubjectParams>({
            query: (params) => ({
                url: `student-group/${params.groupId}/subjects`,
                method: 'POST',
                body: params.groupSubject,
            }),
            invalidatesTags: [{ type: 'GroupSubject', id: 'LIST' }],
        }),

        updateGroupSubject: build.mutation<void, GroupSubjectState>({
            query(data) {
                const { id, ...body } = data
                return {
                    url: `student-group/subjects/${id}`,
                    method: 'PUT',
                    body,
                }
            },
            invalidatesTags: (result, error, { id }) => [
                { type: 'GroupSubject', id },
            ],
        }),

        deleteGroupSubject: build.mutation<void, number>({
            query: (id) => ({
                url: `/student-group/subjects/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, id) => [
                { type: 'GroupSubject', id },
            ],
        }),
    }),
})
